<template>
  <div class="com-skill-label flex align-items-center">
    <yxt-checkbox
      v-model="skillModel.checked"
      :indeterminate="disabled"
      :disabled="disabled"
    >
      <yxt-popover placement="bottom" :max-width="500" trigger="hover">
        <div v-if="skillLevel" class="skill-popover-ctx">
          <div class="mb8">{{ `${$t('pc_biz_training_legend_standard').d('标准')}${skillLevel.name}` }}：</div>
          <div v-if="skillModel.skill.description">{{ ` ${$t('pc_biz_global_lbl_skillDescription').d('能力描述')}：${skillModel.skill.description}` }}</div>
          <div v-if="skillLevel.behavior">{{ `${$t('pc_biz_lbl_level_performance').d('等级行为表现')}：${skillLevel.behavior}` }}</div>
          <div v-if="skillLevel.description">{{ `${$t('pc_biz_global_lbl_levelDescription').d('等级描述')}：${skillLevel.description}` }}</div>
        </div>
        <div v-else class="skill-popover-ctx">
          <div v-if="skillModel.skill.description">{{ `${$t('pc_biz_global_lbl_skillDescription').d('能力描述')}：${skillModel.skill.description}` }}</div>
        </div>
        <span slot="reference">
          <div class="max-w120 ellipsis">
            {{ skillModel.name }}
          </div>
        </span>
      </yxt-popover>
    </yxt-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    skillModel: {
      type: Object,
      default: () => { }
    },
    disabled: Boolean
  },
  computed: {
    skillLevel() {
      const skill = this.skillModel.skill;
      return skill.skillLevelMaps.find(item => item.level === this.skillModel.standardLevel);
    }
  }
};
</script>

<style lang="scss" scoped>
  .com-skill-label {
    .skill-popover-title {
      &__h3 {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        line-height: 24px;
      }
      &__tip {
        font-size: 12px;
        font-weight: 400;
        color: #262626;
        line-height: 22px;
      }
    }
    .skill-popover-ctx {
      font-size: 14px;
      font-weight: 400;
      color: #595959;
      line-height: 22px;
    }
  }
</style>